jQuery(function ($) {
    $(document).ready(function () {
        if ($('.button-modal').length) {
            if (typeof FLBuilder !== 'undefined' && FLBuilder._isEditing) return;

            $('a[href="#donate-modal"]').on('click', function (e) {
                e.preventDefault();
                $('#donate-modal-box').addClass('active');
                $('body').addClass('modal-on');
            });

            $('a[href="#member-modal"]').on('click', function (e) {
                e.preventDefault();
                $('#member-modal-box').addClass('active');
                $('body').addClass('modal-on');
            });

             $('a[href="#alma-modal"]').on('click', function (e) {
                e.preventDefault();
                $('#alma-modal-box').addClass('active');
                $('body').addClass('modal-on');
            });

            $('.button-modal-close').on('click', function (e) {
                e.preventDefault();
                $('body').removeClass('modal-on');
                $('#donate-modal-box, #member-modal-box, #alma-modal-box').removeClass('active');
            });
        }
    });
});
